import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { APP_CONTEXT } from '../../core/models/app-state';
import { UserMapConfig } from '../../core/models/user-map-config';
import { AppStateService } from '../../core/services/app-state.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'places-map-layers-controls',
    templateUrl: './map-layers-controls.component.html',
    styleUrls: ['./map-layers-controls.component.scss'],
    imports: [TranslateModule, MatSlideToggleModule, ReactiveFormsModule, FormsModule],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class MapLayersControlsComponent implements OnInit, OnDestroy {
    private _appState = inject(AppStateService);

    public mapConfig: UserMapConfig;
    public isTrafficDisabled;

    private _ngUnsubscribe$ = new Subject<void>();


    constructor() { }

    ngOnInit() {
        this._appState.getPropertyState('mapConfig')
            .pipe(takeUntil(this._ngUnsubscribe$))
            .subscribe((mapConfig: UserMapConfig) => {
                if (!this.mapConfig) {
                    this.mapConfig = mapConfig;
                }
            });

        this._appState.getPropertyState('selectedContext')
            .pipe(takeUntil(this._ngUnsubscribe$))
            .subscribe((selectedContext: APP_CONTEXT) => {
                this.isTrafficDisabled = selectedContext === APP_CONTEXT.HISTORY;
            });
    }

    ngOnDestroy() {
        this._ngUnsubscribe$.next();
        this._ngUnsubscribe$.complete();
    }


    public updateMapConfig() {
        this._appState.setMapConfig({
            ...this.mapConfig
        });
    }
}
